export const NODE_VERT = `
  attribute vec3 aColor;
  attribute float aSize;
  attribute float aAlpha;
  attribute float aRing;
  uniform float uZoom;
  uniform float uPixelRatio;
  varying vec3 vColor;
  varying float vAlpha;
  varying float vRing;
  void main() {
    vColor = aColor;
    vAlpha = aAlpha;
    vRing = aRing;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    // Room around the disc for the selection ring only.
    gl_PointSize = max(3.0, aSize * 2.0 * 1.3 * uZoom) * uPixelRatio;
  }
`;

// A flat, anti-aliased disc. No border for the selection (owner: "I don't
// like the fat border") — the selected item keeps a bold label instead.
export const NODE_FRAG = `
  uniform vec3 uRingColor;
  varying vec3 vColor;
  varying float vAlpha;
  varying float vRing;
  void main() {
    float d = length(gl_PointCoord - vec2(0.5)) * 2.0;
    if (d > 1.0) discard;
    float aa = fwidth(d) * 1.2;
    float core = 1.0 - smoothstep(0.77 - aa, 0.77, d);
    vec3 color = vColor;
    float alpha = core * vAlpha;
    if (alpha <= 0.0) discard;
    gl_FragColor = vec4(color, alpha);
  }
`;

export const EDGE_VERT = `
  attribute vec3 aColor;
  attribute float aAlpha;
  attribute float aMarch;
  attribute float aDist;
  uniform vec3 uAccent;
  varying vec3 vColor;
  varying float vAlpha;
  varying float vMarch;
  varying float vDist;
  void main() {
    vColor = mix(aColor, uAccent, aMarch);
    vAlpha = aAlpha;
    vMarch = aMarch;
    vDist = aDist;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

// Dots measured in SCREEN pixels (distance along the curve × zoom), so they
// keep their size at every zoom. One rhythm for every link (owner: the spacing
// at rest must match hover); a focused link only changes colour and FLOWS
// from its source to its target.
export const EDGE_FRAG = `
  uniform float uZoom;
  uniform float uTime;
  varying vec3 vColor;
  varying float vAlpha;
  varying float vMarch;
  varying float vDist;
  void main() {
    float px = vDist * uZoom;
    float period = 9.0;
    float on = 4.5;
    float phase = mod(px - uTime * 36.0 * vMarch, period);
    float dotMask = 1.0 - smoothstep(on - 0.6, on + 0.6, phase);
    float alpha = vAlpha * dotMask;
    if (alpha <= 0.003) discard;
    gl_FragColor = vec4(vColor, alpha);
  }
`;
